import React from 'react';
import { InfiniteSlider } from './ui/infinite-slider';
import { useTranslation } from '../translations';

const logos = [
  {
    name: 'Europ Assistance',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/Europassistance-1.png'
  },
  {
    name: 'Belfius',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/Belfius.png'
  },
  {
    name: 'DVV',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/DVV-logo.png'
  },
  {
    name: 'Belfius Direct',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/belfiusdirect-logo.svg'
  },
  {
    name: 'Robi',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/LOGO_RBNTT.png'
  },
  {
    name: 'Verisure',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/Verisure_Logo_-_2021-07-16.png'
  },
  {
    name: 'Engie',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/Logo-engie.png'
  },
  {
    name: 'Veton',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/veton-logo.svg'
  },
  {
    name: 'Mega',
    url: 'https://guurrickmxxnxobbsjbp.supabase.co/storage/v1/object/public/Images/Slider%20Logo/logo_positive_RVB.png'
  }
];

export function LogoSlider() {
  const { t } = useTranslation();

  return (
    <InfiniteSlider 
      gap={48} 
      duration={30} 
      durationOnHover={60} 
      className="w-full py-8"
    >
      {logos.map((logo, index) => (
        <div 
          key={index} 
          className="flex-shrink-0 h-12 w-32 flex items-center justify-center group"
        >
          <img
            src={logo.url}
            alt={`${logo.name} logo`}
            className="max-h-full max-w-full object-contain transition-all duration-300 filter brightness-0 invert opacity-70 group-hover:filter-none group-hover:opacity-100"
          />
        </div>
      ))}
    </InfiniteSlider>
  );
}